"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBBreadCrumb", {
  enumerable: true,
  get: function get() {
    return _SVBBreadCrumb.default;
  }
});
var _SVBBreadCrumb = _interopRequireDefault(require("./src/SVBBreadCrumb"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }